import { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// Components
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import FelicitacionesXVEstrellas from '../CuestionarioXVEstrellas/FelicitacionesXVEstrellas';

import Banner from '../Banner';
// import RecommendedCarousel from '../RecommendedCarousel';

// Queries
import tokenAdminMX from '../Queries/tokenAdminMX';
import getAdminCarritoMX from '../Queries/getAdminCarritoMX';

// Styles
import styles from './index.module.sass';

// Image
import Product1 from '../../images/home/product1.jpg';

const location = process.env.REACT_APP_COUNTRY;

export default function ConsultancyHome({ device = {}, setSessionMessage }) {
  const { screenSize } = device;
  const { t } = useTranslation('consultancyhome');

  const styleModalXVEstrellas = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: screenSize === 'phone' ? '90%' : '60%',
    background: 'radial-gradient(ellipse 70% 80%, #f1f3f4 70%, #002747 100%)',
    boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.8)',
    p: 2,
    borderRadius: 10,
  };

  const promo1 = t('promo1', { returnObjects: true });
  const promo2 = t('promo2', { returnObjects: true });

  const [isOpen, setIsOpenModal] = useState(false);
  const [idCuestionario, setidCuestionario] = useState('');

  const handleClose = () => setIsOpenModal(false);

  // Para conocer el Token y obtener el Cuestionario
  const getCuestionario = useCallback(async () => {
    try {
      // Obtener el token
      const tokenResponse = await tokenAdminMX({
        tmbservice: 'WebApiLoginMX/api/login/administracionusa',
      });

      const {
        codigoMensaje: tokenCodigo,
        mensajeEsp: tokenMensaje,
        data: tokenData = {},
      } = tokenResponse;

      setSessionMessage(tokenCodigo);

      if (tokenCodigo === 200) {
        const now = new Date();
        const expireTime = now.getTime() + 1000 * 36000;
        now.setTime(expireTime);

        document.cookie = `TokenNvoAdminMX=${
          tokenData.tokenLogin
        };expires=${now.toUTCString()};path=/`;

        document.cookie = `nivelConsultora=${tokenData.nivel};expires=${now.toUTCString()};path=/`;

        // Obtener el cuestionario después de tener el token
        const cuestionarioResponse = await getAdminCarritoMX({
          tmbservice: 'WebApiAdminCarritoMX/api/CuestionariosUSA/Pendientes',
        });

        const { codigoMensaje: cuestionarioCodigo, data: cuestionarioData = '' } =
          cuestionarioResponse;

        if (cuestionarioCodigo === 200) {
          setIsOpenModal(true);
          setidCuestionario(cuestionarioData.dataCuestionario[0].id);
        } else {
          setIsOpenModal(false);
        }
      } else {
        console.log(tokenMensaje, 'XV Estrellas');
      }
    } catch (error) {
      console.error('Error al obtener el token o el cuestionario:', error);
    }
  }, [setSessionMessage]);

  useEffect(() => {
    getCuestionario();
  }, [getCuestionario]);

  return (
    <div id={styles.Home} className={styles[screenSize]}>
      <Banner device={device} />
      {/* <RecommendedCarousel device={device} /> */}

      {isOpen ? (
        <Modal open={isOpen} onClose={handleClose}>
          <Box sx={styleModalXVEstrellas}>
            <FelicitacionesXVEstrellas
              idCuestionario={idCuestionario}
              setIsOpenModal={setIsOpenModal}
              setSessionMessage={setSessionMessage}
              screenSize={screenSize}
            />
          </Box>
        </Modal>
      ) : (
        <div></div>
      )}
      <div className={`${styles.promo} ${styles.left}`}>
        <div className={`${styles.promoTextContainer} ${styles.promoLeft}`}>
          <div className={styles.cursiveBlue}>{promo1.text1}</div>
          <div className={styles.capitalBlue}>{promo1.text2}</div>
          <div className={styles.capitalGold}>{promo1.text3}</div>
          <div className={styles.descriptionText}>{promo1.text4}</div>
        </div>
        <div className={styles.promoImageContainer}>
          <img src={Product1} alt='' className={styles.promoImage} />
        </div>
      </div>

      {location === 'US' && (
        <div className={`${styles.promo} ${styles.right}`}>
          <div className={styles.promoImageContainer}>
            <img
              src='https://webimages.terramarbrands.com.mx/usawebpage/home/producto-estrella-usa-2.jpg'
              alt=''
              className={styles.promoImage}
            />
          </div>
          <div className={`${styles.promoTextContainer} ${styles.promoRight}`}>
            <div className={styles.capitalGold}>{promo2.text1}</div>
            <div className={styles.cursiveBlue}>{promo2.text2}</div>
            <div className={styles.descriptionText}>{promo2.text3}</div>
          </div>
        </div>
      )}
    </div>
  );
}
